<template>
  <div
    class="cookies"
    :class="{ 'cookies--open': openWindow }"
  >
    <div
      class="cookies__window"
      :class="{ 'cookies__window--open': openWindow }"
    >
      <div class="cookies__window__container">
        <div class="cookies__window__container__header">
          <div class="cookies__window__container__header__icon">
            <i class="icon-bliss" />
          </div>
          <div class="cookies__window__container__header__title">
            <h1>{{ $t("privacy_settings") }}</h1>
          </div>
        </div>
        <div class="cookies__window__container__content">
          <div class="cookies__window__container__content__nav">
            <div
              v-for="(item, index) in cookiesList"
              :key="index"
            >
              <div
                class="cookies__window__container__content__nav__item"
                :class="{
                  'cookies__window__container__content__nav__item--selected':
                    infoItem.id === item.id,
                }"
                @click="setItem(item)"
              >
                <h3>
                  {{ item.title }}
                </h3>
              </div>
            </div>
          </div>

          <div
            class="cookies__window__container__content__info"
            :class="{
              'cookies__window__container__content__info--fadein': cloneId,
            }"
          >
            <div class="cookies__window__container__content__info__header">
              <div
                class="cookies__window__container__content__info__header__title"
              >
                <h3>{{ infoItem.title }}</h3>
              </div>
              <div
                v-if="infoItem.toggle"
                class="cookies__window__container__content__info__header__toggle"
              >
                <toggle-view @setResult="getToggleInfo" />
              </div>
            </div>
            <div class="cookies__window__container__content__info__text">
              <p>
                {{ infoItem.text }}
              </p>
            </div>
          </div>
        </div>

        <div class="cookies__window__container__responsive">
          <dropdown-expanded-view
            :items="cookiesList"
            @toggleInfo="getToggleInfo"
          />
        </div>

        <div class="cookies__window__container__buttons">
          <div @click="acceptAllCookies">
            <button-view variant="special full">
              {{ $t("cookies_3") }}
            </button-view>
          </div>
          <div @click="saveCookies">
            <button-view variant="primary full">
              {{ $t("cookies_4") }}
            </button-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as cookie from '@/utils/cookies';

export default {
  name: 'CookiesView',

  components: {
    ButtonView: () => import('@/components/button/button-view'),
    DropdownExpandedView: () => import('@/components/dropdown/dropdown-expanded-view'),
    ToggleView: () => import('@/components/toggle/toggle-view')
  },

  props: {
    openWindow: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      infoItem: {},
      cookie: cookie,
      cloneId: false,
      cookiesList: this.$i18n.t('cookies_list'),
      toggleResult: true
    };
  },
  mounted() {
    this.setItem(this.cookiesList[0]);
    this.cookie.setInCookies();
  },

  methods: {
    setItem(item) {
      if (!item.link) {
        if (this.infoItem.id !== item.id) {
          this.infoItem = item;
          this.cloneId = false;
          setTimeout(() => {
            this.cloneId = true;
          }, 1);
        }
      } else {
        let routeData = this.$router.resolve({ name: 'privacy_policy' });
        window.open(routeData.href, '_blank');
      }
    },

    getToggleInfo(result) {
      this.toggleResult = result;
    },

    saveCookies() {
      if (this.toggleResult) {
        this.acceptAllCookies();
      } else {
        this.$emit('closeDetails');
        this.cookie.setCookie('cookies-bliss', 'Cookies-wChanges');
      }
    },
    acceptAllCookies() {
      this.$emit('closeDetails');
      this.cookie.setCookie('cookies-bliss', 'All-Cookies');
      this.cookie.setGaCookies(false);
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/cookies/cookies-view.scss"></style>



// WEBPACK FOOTER //
// cookies-view.vue